module.exports = __webpack_public_path__ + "public/img/title-lmqd.36d1b563.png";